<template>
  <div v-if="selectedPost">
    <transition
      name="reouter-anim"
      :duration="{enter: 800, leave: 300}"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in"
    >
      <PostShow :post="selectedPost" :key="this.$route.params.slug" :style="getZoomByScreen()" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import PostShow from "@/components/Posts/PostShow";
import axios from "axios";
export default {
  components: {
    PostShow
  },
  computed: {
    ...mapState("posts", ["selectedPost"])
  },
  methods: {
    ...mapActions("posts", ["fetchPost"]),
    ...mapActions("comments", ["fetchComments"]),
    ...mapMutations("posts", ["setPost"]),
    getZoomByScreen() {
      if (window.innerWidth <= 1366 && window.innerWidth >= 960)
        return "margin-bottom: -300px;";
    }
  },
  created() {
    let postSlug = this.$route.params.slug;
    this.fetchPost(postSlug);
    // await this.fetchComments({ postId: this.selectedPost.id, page: 1 })
  },
  beforeRouteUpdate (to, from, next) {
    let postSlug = to.params.slug;
    this.fetchPost(postSlug);
    next();
  },
};
</script>
